// babel polyfill should handle most polyfill needs...except this one, apparently

module.exports = {
    NodelistForeach: require('./NodelistForeach'),
    UrlSearchParamsPolyfills: require('./url-search-params-polyfills'),
  }
  